import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'

import api from '../services/api'
import { getUserCode, paramsToObject } from '../utils/functions'

import './styles/DefaultReg.css';
import FooterDelphus from '../components/FooterDelphus';
import FrImageEdit from '../components/FrImageEdit'
import FrDatePicker from '../components/FrDatePicker';

const swal = withReactContent(Swal)

function Estoques() {
  const [data, setData] = useState({})
  const [updateType, setUpdateType] = useState(false)
  const [comboPac, setComboPac] = useState([{ value: '', display: '' }])
  const [comboUni, setComboUni] = useState([{ value: '', display: '' }])
  const [comboMdc, setComboMdc] = useState([{ value: '', display: '' }])
  const [comboMat, setComboMat] = useState([{ value: '', display: '' }])
  const [enableEdit, setEnableEdit] = useState('N')
  const [comboTme, setComboTme] = useState([{ value: '', display: '' }])
  const [comboCobrado, setComboCobrado] = useState([{ value: 'S', display: 'Sim' },{ value: 'N', display: 'Não' },])
  
  const [pk_est, setpk_est] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      let pacientes = await api.getComboData('pacientes')
      pacientes.unshift({ display: 'Residencial Primavera', value: 'null' })
      setComboPac(pacientes)
      setComboUni(await api.getComboData('unidades_medida'))
      setComboMat(await api.getComboData('materiais'))
      setComboMdc(await api.getComboData('medicamentos'))
      setComboTme(await api.getComboData('tipo_mov_estoque'))

      if (query.codigo > 0) {
        setUpdateType(true)
        setpk_est(query.codigo)
        api.get('/movimentacao_estoque?pk_mit=' + query.codigo).then(r => {
          if (r.data[0]) {
            console.log(r.data[0])
            setData(r.data[0])
            swal.close()
          } else {
            swal.fire('Código inválido', 'Código informado não encontrado!', 'warning')
              .then((result) => {
                if (result.value) {
                  window.history.back()
                }
              })
          }
        })
      } else swal.close()
    }

    fetchData()
  }, [])

  function consistData(data) {
    let required = [
      'fk_uni',
    ]

    let errors = []

    required.forEach((curr, index) => {
      let fieldName = curr
      if (curr === 'fk_uni') fieldName = 'Unidade de Medida'

      if (!data[curr]) return errors.push(fieldName)

      if ((!data['fk_mat']) && (!data['fk_mdc'])) return errors.push('Material ou Medicamento')
      if ((data['fk_mat']) && (data['fk_mdc'])) return errors.push('Material ou Medicamento')


    })

    return errors
  }

  function handleSubmit(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja salvar " + (updateType ? 'as alterações' : 'a inclusão') + ' do registro?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        const auxValues = { ...data };
        let errors = consistData(auxValues)
        console.log(errors.length)
        if (errors.length === 0) {
          if (updateType) {
            api.post('/estoques/edit', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Alterado',
                  text: "O registro foi alterado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi alterado!",
                  icon: 'warning',
                })
              }
            })
          } else {
            api.post('/estoques/add', auxValues).then(r => {
              if (r.status === 200) {
                swal.fire({
                  title: 'Registro Adicionado',
                  text: "O registro foi adicionado com sucesso!",
                  icon: 'success',
                }).then((result) => {
                  if (result.value) {
                    window.history.back()
                  }
                })
              } else {
                swal.fire({
                  title: 'Erro!',
                  text: "O registro não foi adicionado!",
                  icon: 'warning',
                })
              }
            })
          }
        } else {
          swal.fire({
            title: 'Erro!',
            text: "Verifique o(s) campo(s) " + errors.join(','),
            icon: 'warning',
          })
        }
      }
    })
  }

  function handleCancel(e) {
    e.preventDefault();
    swal.fire({
      title: 'ATENÇÃO',
      text: "Caso cancele a alteração/inclusão, todos os dados digitados serão perdidos. Confirma?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        window.history.back()
      }
    })
  }

  const handleChange = (e) => {
    const auxValues = { ...data };
    switch (e.target.name) {
      case 'CNPJ':
      default: auxValues[e.target.name] = e.target.value;
    }
    setData(auxValues);
  };

  return (
    <div className="defaultReg">
      <NavBar />
      <div className="defaultRegContent">
        <div className="defaultHeader">
          <h3>Visualização de Movimentação de Estoque</h3>
          <UserOptions />
        </div>
        <br />
        <form id="regForm" onSubmit={handleSubmit}>

        <FrDatePicker
            value={(data.data_mov || '').split('T')[0]}
            onChange={handleChange}
            name="data_mov"
            id="data_mov"
            color="#528b46"
            label="Data Movimento"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 180 }}

          />

          <FrSelect
            value={data.fk_mat || ''}
            onChange={handleChange}
            name="fk_mat"
            id="fk_mat"
            label='Material'
            data={comboMat}
            style={{ width: 300 }}
            disabled
          />

          <FrSelect
            value={data.fk_mdc || ''}
            onChange={handleChange}
            name="fk_mdc"
            id="fk_mdc"
            label='Medicamento'
            data={comboMdc}
            style={{ width: 300 }}
            disabled
          />

          <FrSelect
            value={data.fk_pac || ''}
            onChange={handleChange}
            name="fk_pac"
            id="fk_pac"
            label='Residente'
            data={comboPac}
            style={{ width: 300 }}
            disabled
          />


          <br />
          <FrSelect
            value={data.fk_uni || ''}
            onChange={handleChange}
            name="fk_uni"
            id="fk_uni"
            label='Unidade de Medida'
            data={comboUni}
            style={{ width: 150 }}
            disabled
          />


          <FrTextInput
            maxLength='10'
            value={data.quantidade || ''}
            onChange={handleChange}
            name="quantidade"
            id="quantidade"
            color="#528b46"
            label="Quantidade"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 130 }}
          />

          <FrSelect
            value={data.fk_tme || ''}
            onChange={handleChange}
            name="fk_tme"
            id="fk_tme"
            label='Tipo de Movimentação'
            data={comboTme}
            style={{ width: 300 }}
            disabled
          />
          
          <FrSelect
            value={data.cobrada || ''}
            onChange={handleChange}
            name="cobrada"
            id="cobrada"
            label='Cobrado'
            data={comboCobrado}
            style={{ width: 100 }}
            disabled
          />
          
          <FrTextInput
            maxLength='10'
            value={data.familiar || ''}
            onChange={handleChange}
            name="familiar"
            id="familiar"
            color="#528b46"
            label="Familiar"
            variant="outlined"
            size="small"
            disabled
            style={{ width: 300 }}
          />
          <div className="regFoto" >
            <FrImageEdit readOnly={true} image={data.imagem_mov} pk_est={pk_est} />
          </div>


        </form>
        <div className="regButtonsDiv">
          {(enableEdit === 'S') ?
            (<button onClick={handleSubmit}>Salvar</button>) : (<></>)}
          <button onClick={handleCancel}>{(enableEdit === 'S') ? 'Cancelar' : 'Fechar'}</button>
        </div>
        <FooterDelphus />
      </div>
    </div >
  );
}

export default Estoques;
